import { createGlobalStyle } from 'styled-components';
import { colors, zIndexes, MediaQuery } from './style-helpers';

const GlobalStyles = createGlobalStyle`
    body {
        background-color: ${colors.WHITE};
        height:100%;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-family: 'Montserrat', sans-serif !important;
        padding: 0;
        margin: 0;
    }
    html {
        height:100%;
        font-size: 62.5%;
    }
    img {
        max-width: 100%;
    }

    .the_modal_overlay{
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: ${colors.BLACK + colors.OPACITY_70_ALPHA_HEX_SUFFIX};
        z-index: ${zIndexes.MODAL};
    }

    .the_modal{
        max-width: 90em;
        background-color: ${colors.LIGHT_GREY};
        height: auto;
        max-height: 90em;
        overflow-y: auto;
        padding: 0 0 48px 0;
        flex-grow: 0;
        display: flex;
        flex-direction: column;

        ${MediaQuery.xSmall`
            width: 100%;
            height: 100%;
            max-height: 100%;
        `}
    }
`;

export default GlobalStyles;
